<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="业务类型">
              <a-select
                @change="searchQuery"
                default-value="1"
                v-model="queryParam.firmType"
                placeholder="请选择业务类型"
              >
                <a-select-option value="1">
                  认购
                </a-select-option>
                <a-select-option value="2">
                  申购
                </a-select-option>
                <a-select-option value="3">
                  定投
                </a-select-option>
                <a-select-option value="4">
                  转换
                </a-select-option>
                <a-select-option value="5">
                  修改分红
                </a-select-option>
                <a-select-option value="6">
                  赎回
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="客户名称">
              <a-input
                placeholder="请输入客户名称"
                v-model="queryParam.clientName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="证件号码">
              <a-input
                placeholder="请输入证件号码"
                v-model="queryParam.cardNum"
              ></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="产品名称">
                <a-input
                  placeholder="请输入产品名称"
                  v-model="queryParam.prdName"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="交易编号">
                <a-input
                  placeholder="请输入交易编号"
                  v-model="queryParam.allotNo"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="交易渠道">
                <a-select
                  v-model="queryParam.tradeChannel"
                  placeholder="请选择"
                >
                  <a-select-option
                    v-for="(item, index) in channelList"
                    :key="index"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="12" :lg="10" :md="11" :sm="24">
              <a-form-item label="申请日期">
                <a-date-picker
                  placeholder="请选择日期"
                  :disabled-date="disabledStartDate"
                  format="YYYY-MM-DD"
                  value-format="yyyy-MM-dd"
                  v-model="queryParam.startDate"
                ></a-date-picker
                >~~
                <a-date-picker
                  placeholder="请选择日期"
                  :disabled-date="disabledEndDate"
                  format="YYYY-MM-DD"
                  value-format="yyyy-MM-dd"
                  v-model="queryParam.endDate"
                ></a-date-picker>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left;overflow: hidden;"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- table区域-begin -->
    <a-table
      ref="table"
      size="middle"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      class="j-table-force-nowrap"
      @change="handleTableChange"
    >
      <template slot="htmlSlot" slot-scope="text">
        <div v-html="text"></div>
      </template>
      <template slot="firmType" slot-scope="text">
        {{ queryParam.firmType == '1' ? '认购' : '' }}
        {{ queryParam.firmType == '2' ? '申购' : '' }}
        {{ queryParam.firmType == '3' ? '定投' : '' }}
        {{ queryParam.firmType == '4' ? '转换' : '' }}
        {{ queryParam.firmType == '5' ? '修改分红' : '' }}
        {{ queryParam.firmType == '6' ? '赎回' : '' }}
      </template>
      <template slot="tradeChannel" slot-scope="text, record">
        <span
          v-for="(item, index) in channelList"
          :key="index"
          v-if="item.code == record.tradeChannel"
        >
          {{ item.name }}
        </span>
      </template>
      <template slot="status" slot-scope="text, record">
        {{ record.allotNo ? '提交成功' : '提交失败' }}
      </template>
      <template slot="applyDate" slot-scope="text, record">
        {{ record.applyDate ? dateFormat(record.applyDate) : '' }}
      </template>
      <template slot="imgSlot" slot-scope="text">
        <span v-if="!text" style="font-size: 12px;font-style: italic;"
          >无图片</span
        >
        <img
          v-else
          :src="getImgView(text)"
          height="25px"
          alt=""
          style="max-width:80px;font-size: 12px;font-style: italic;"
        />
      </template>

      <span slot="action" slot-scope="text, record">
        <a
          v-show="record.allotNo && record.clientId"
          @click="handleSearch(record)"
          >查看详情</a
        >
      </span>
    </a-table>
    <!--
    <trade-search-modal ref="modalForm" @ok="modalFormOk"></trade-search-modal>
-->
    <a-modal
      :visible="visible"
      title="交易详情"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div
        v-if="
          queryParam.firmType == 1 ||
            queryParam.firmType == 2 ||
            queryParam.firmType == 3 ||
            queryParam.firmType == 6
        "
      >
        <a-descriptions :column="2">
          <a-descriptions-item label="客户名称">
            {{ record.realName }}
          </a-descriptions-item>
          <a-descriptions-item label="证件号码">
            {{ record.idNo }}
          </a-descriptions-item>
          <a-descriptions-item label="基金账号">
            {{ orderDetails.ta_acco }}
          </a-descriptions-item>
          <a-descriptions-item label="交易编号">
            {{ record.allotNo }}
          </a-descriptions-item>
        </a-descriptions>
        <a-descriptions :column="2" title="买入信息">
          <a-descriptions-item label="产品代码">
            {{ orderDetails.fund_code }}
          </a-descriptions-item>
          <a-descriptions-item label="产品名称">
            {{ orderDetails.fund_name }}
          </a-descriptions-item>
          <a-descriptions-item label="业务类型">
            {{ queryParam.firmType == '1' ? '认购' : '' }}
            {{ queryParam.firmType == '2' ? '申购' : '' }}
            {{ queryParam.firmType == '3' ? '定投' : '' }}
            {{ queryParam.firmType == '4' ? '转换' : '' }}
            {{ queryParam.firmType == '5' ? '修改分红' : '' }}
            {{ queryParam.firmType == '6' ? '赎回' : '' }}
          </a-descriptions-item>
          <a-descriptions-item label="银行卡号">
            {{ orderDetails.bank_account }}
          </a-descriptions-item>
          <a-descriptions-item label="交易渠道">
            <span
              v-for="(item, index) in channelList"
              :key="index"
              v-if="item.code == record.tradeChannel"
            >
              {{ item.name }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item label="交易账号">
            {{ orderDetails.trade_acco }}
          </a-descriptions-item>
          <a-descriptions-item label="申请时间">
            {{ dateFormat(orderDetails.apply_date) }}
          </a-descriptions-item>
          <a-descriptions-item label="申请金额">
            {{ orderDetails.balance }}{{ '元' }}
          </a-descriptions-item>
          <a-descriptions-item label="申请份额">
            {{ orderDetails.apply_share }}{{ '份' }}
          </a-descriptions-item>
        </a-descriptions>
        <a-descriptions :column="2" title="确认信息">
          <a-descriptions-item label="扣款状态">
            {{ orderDetails.deduct_status == '0' ? '未校验' : '' }}
            {{ orderDetails.deduct_status == '1' ? '无效' : '' }}
            {{ orderDetails.deduct_status == '2' ? '有效' : '' }}
            {{ orderDetails.deduct_status == '3' ? '已发送扣款指令' : '' }}
          </a-descriptions-item>
          <a-descriptions-item label="确认状态">
            {{ orderDetails.trade_status == '0' ? '确认失败' : '' }}
            {{ orderDetails.trade_status == '1' ? '确认成功' : '' }}
            {{ orderDetails.trade_status == '2' ? '部分确认' : '' }}
            {{ orderDetails.trade_status == '3' ? '实时确认成功' : '' }}
            {{ orderDetails.trade_status == '4' ? '已撤销交易' : '' }}
            {{ orderDetails.trade_status == '5' ? '认购行为确认' : '' }}
            {{ orderDetails.trade_status == '9' ? '未处理' : '' }}
          </a-descriptions-item>
          <a-descriptions-item label="确认时间">
            {{ dateFormat(orderDetails.affirm_date) }}
          </a-descriptions-item>
          <a-descriptions-item label="确认金额">
            {{ orderDetails.trade_confirm_balance }}{{ '元' }}
          </a-descriptions-item>
          <a-descriptions-item label="确认份额">
            {{ orderDetails.trade_confirm_shares }}{{ '份' }}
          </a-descriptions-item>
          <a-descriptions-item label="手续费">
            {{ orderDetails.fare_sx }}{{ '元' }}
          </a-descriptions-item>
        </a-descriptions>
      </div>
      <div v-if="queryParam.firmType == 4">
        <a-descriptions :column="2">
          <a-descriptions-item label="客户名称">
            {{ record.realName }}
          </a-descriptions-item>
          <a-descriptions-item label="证件号码">
            {{ record.idNo }}
          </a-descriptions-item>
          <a-descriptions-item label="基金账号">
            {{ orderDetails.ta_acco }}
          </a-descriptions-item>
          <a-descriptions-item label="交易编号">
            {{ record.allotNo }}
          </a-descriptions-item>
        </a-descriptions>
        <a-descriptions :column="2" title="买入信息">
          <a-descriptions-item label="产品代码">
            {{ orderDetails.fund_code }}
          </a-descriptions-item>
          <a-descriptions-item label="产品名称">
            {{ orderDetails.fund_name }}
          </a-descriptions-item>
          <a-descriptions-item label="业务类型">
            {{ queryParam.firmType == '1' ? '认购' : '' }}
            {{ queryParam.firmType == '2' ? '申购' : '' }}
            {{ queryParam.firmType == '3' ? '定投' : '' }}
            {{ queryParam.firmType == '4' ? '转换' : '' }}
            {{ queryParam.firmType == '5' ? '修改分红' : '' }}
            {{ queryParam.firmType == '6' ? '赎回' : '' }}
          </a-descriptions-item>
          <a-descriptions-item label="银行卡号">
            {{ orderDetails.bank_account }}
          </a-descriptions-item>
          <a-descriptions-item label="交易渠道">
            <span
              v-for="(item, index) in channelList"
              :key="index"
              v-if="item.code == record.tradeChannel"
            >
              {{ item.name }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item label="交易账号">
            {{ orderDetails.trade_acco }}
          </a-descriptions-item>
          <a-descriptions-item label="申请时间">
            {{ dateFormat(orderDetails.apply_date) }}
          </a-descriptions-item>
          <a-descriptions-item label="转换份额">
            {{ record.shares }}{{ '份' }}
          </a-descriptions-item>
          <a-descriptions-item label="转入基金代码">
            {{ orderDetails.target_fund_code }}
          </a-descriptions-item>
        </a-descriptions>
        <a-descriptions :column="2" title="确认信息">
          <a-descriptions-item label="扣款状态">
            {{ orderDetails.deduct_status == '0' ? '未校验' : '' }}
            {{ orderDetails.deduct_status == '1' ? '无效' : '' }}
            {{ orderDetails.deduct_status == '2' ? '有效' : '' }}
            {{ orderDetails.deduct_status == '3' ? '已发送扣款指令' : '' }}
          </a-descriptions-item>
          <a-descriptions-item label="确认状态">
            {{ orderDetails.trade_status == '0' ? '确认失败' : '' }}
            {{ orderDetails.trade_status == '1' ? '确认成功' : '' }}
            {{ orderDetails.trade_status == '2' ? '部分确认' : '' }}
            {{ orderDetails.trade_status == '3' ? '实时确认成功' : '' }}
            {{ orderDetails.trade_status == '4' ? '已撤销交易' : '' }}
            {{ orderDetails.trade_status == '5' ? '认购行为确认' : '' }}
            {{ orderDetails.trade_status == '9' ? '未处理' : '' }}
          </a-descriptions-item>
          <a-descriptions-item label="确认时间">
            {{ dateFormat(orderDetails.affirm_date) }}
          </a-descriptions-item>
          <a-descriptions-item label="确认金额">
            {{ orderDetails.trade_confirm_balance }}{{ '元' }}
          </a-descriptions-item>
          <a-descriptions-item label="确认份额">
            {{ orderDetails.trade_confirm_shares }}{{ '份' }}
          </a-descriptions-item>
          <a-descriptions-item label="手续费">
            {{ orderDetails.fare_sx }}{{ '元' }}
          </a-descriptions-item>
        </a-descriptions>
      </div>
      <div v-if="queryParam.firmType == 5">
        <a-descriptions :column="2">
          <a-descriptions-item label="客户名称">
            {{ record.realName }}
          </a-descriptions-item>
          <a-descriptions-item label="证件号码">
            {{ record.idNo }}
          </a-descriptions-item>
          <a-descriptions-item label="基金账号">
            {{ orderDetails.ta_acco }}
          </a-descriptions-item>
          <a-descriptions-item label="交易编号">
            {{ record.allotNo }}
          </a-descriptions-item>
          <a-descriptions-item label="产品代码">
            {{ orderDetails.fund_code }}
          </a-descriptions-item>
          <a-descriptions-item label="产品名称">
            {{ orderDetails.fund_name }}
          </a-descriptions-item>
          <a-descriptions-item label="业务类型">
            <a-descriptions-item label="业务类型">
              {{ queryParam.firmType == '1' ? '认购' : '' }}
              {{ queryParam.firmType == '2' ? '申购' : '' }}
              {{ queryParam.firmType == '3' ? '定投' : '' }}
              {{ queryParam.firmType == '4' ? '转换' : '' }}
              {{ queryParam.firmType == '5' ? '修改分红' : '' }}
              {{ queryParam.firmType == '6' ? '赎回' : '' }}
            </a-descriptions-item>
          </a-descriptions-item>
          <a-descriptions-item label="交易渠道">
            <span
              v-for="(item, index) in channelList"
              :key="index"
              v-if="item.code == record.tradeChannel"
            >
              {{ item.name }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item label="原分红方式">
            {{ record.oriAutoBuy }}
          </a-descriptions-item>
          <a-descriptions-item label="现分红方式">
            {{ orderDetails.auto_buy }}
          </a-descriptions-item>
          <a-descriptions-item label="申请时间">
            {{ dateFormat(orderDetails.apply_date) }}
          </a-descriptions-item>
          <a-descriptions-item label="确认时间">
            {{ dateFormat(orderDetails.affirm_date) }}
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import { getAction } from '@/api/manage';
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue';
import moment from 'moment';
/*
  import TradeSearchModal from "./modules/TradeSearchModal";
*/

export default {
  name: 'TradeInfoList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JDictSelectTag
  },
  data() {
    return {
      description: '交易信息查询页面',
      channelVisible: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      startDate: undefined,
      endDate: undefined,
      channelList: [],
      queryParam: {
        firmType: '1'
      },
      record: {},
      visible: false,
      orderDetails: {},
      // 表头
      columns: [
        {
          title: '交易编号',
          align: 'center',
          dataIndex: 'allotNo',
          customRender: function(text) {
            return !text
              ? ''
              : text.length > 10
              ? text.substr(0, 12) + '...'
              : text;
          }
        },
        {
          title: '客户名称',
          align: 'center',
          dataIndex: 'realName'
        },
        {
          title: '证件号码',
          align: 'center',
          dataIndex: 'idNo',
          customRender: function(text) {
            return !text
              ? ''
              : text.length > 10
              ? text.substr(0, 12) + '...'
              : text;
          }
        },
        {
          title: '交易渠道',
          align: 'center',
          dataIndex: 'tradeChannel',
          scopedSlots: { customRender: 'tradeChannel' }
        },
        {
          title: '业务类型',
          align: 'center',
          dataIndex: 'firmType',
          scopedSlots: { customRender: 'firmType' }
        },
        {
          title: '产品代码',
          align: 'center',
          dataIndex: 'fundCode',
          scopedSlots: { customRender: 'fundCode' }
        },
        {
          title: '客户编号',
          dataIndex: 'clientId',
          align: 'center'
        },
        {
          title: '申请日期',
          align: 'center',
          dataIndex: 'applyDate',
          scopedSlots: { customRender: 'applyDate' }
        },
        {
          title: '申请份额',
          align: 'center',
          dataIndex: 'shares',
          scopedSlots: { customRender: 'shares' }
        },
        {
          title: '交易状态',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        channelList: process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/list',
        query:
          process.env.VUE_APP_CMS_TRADE + '/trade/tradeInfo/traderesultQuery'
      }
    };
  },
  created() {
    this.getChannelList();
  },
  methods: {
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    handleCancel(e) {
      console.log('Clicked cancel button');
      this.visible = false;
    },
    handleSearch(record) {
      this.record = { ...record };
      console.log(record);
      this.visible = true;
      getAction(this.url.query, {
        allotNo: record.allotNo,
        clientId: record.clientId
      }).then(res => {
        this.orderDetails = { ...res.result };
        console.log(this.orderDetails);
      });
    },
    getChannelList() {
      getAction(this.url.channelList).then(res => {
        if (res.success) {
          this.channelList = res.result.records;
        }
      });
    },
    search() {
      if (this.startDate) {
        this.queryParam.startDate = moment(this.startDate).format('YYYY-MM-DD');
      }
      if (this.endDate) {
        this.queryParam.endDate = moment(this.endDate).format('YYYY-MM-DD');
      }
      this.searchQuery();
    },
    searchResetForm() {
      this.startDate = undefined;
      this.endDate = undefined;
      this.searchReset();
    },
    disabledEndDate(endValue) {
      console.log(endValue);
      const startValue = moment(this.startDate, 'YYYY-MM-DD');
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    disabledStartDate(startValue) {
      console.log(startValue);
      const endValue = moment(this.endDate, 'YYYY-MM-DD');
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    initDictConfig() {},
    loadData(arg) {
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      if (!this.queryParam.firmType) {
        this.queryParam.firmType = '1';
      }
      var params = { ...this.getQueryParams() }; //查询条件
      if (params.startDate) {
        params.startDate = moment(params.startDate).format('YYYYMMDD');
      }
      if (params.endDate) {
        params.endDate = moment(params.endDate).format('YYYYMMDD');
      }
      this.loading = true;
      getAction(
        process.env.VUE_APP_CMS_TRADE + '/trade/tradeInfo/list',
        params
      ).then(res => {
        if (res.success) {
          this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
        this.loading = false;
      });
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
